import { MouseEventHandler } from 'react';
import EditIconPurpleSmall from 'packages/kakapo-ui-kit/assets/icons/EditIconPurpleSmall';
import CircleButton from 'packages/kakapo-ui-kit/components/editors/CircleButton';

interface IProps {
	onClick: MouseEventHandler<HTMLElement>;
	size?: number;
	isLight?: boolean;
}

export default function EditButton({ onClick, size = 24, isLight = true }: IProps) {
	return (
		<CircleButton
			color="primary"
			shouldOverrideIconColor
			size={size}
			isLight={isLight}
			onClick={onClick}
		>
			<EditIconPurpleSmall color="white" />
		</CircleButton>
	);
}
